const CreateTermApplicant_mutate = `
    mutation createTermApplicant( 
      $applicantId: Int!     
      $termId: Int!    
      $applicationAccepted: Boolean
      $applicantStatus: String
      $applicationStatus: String
      $answers: String!
      ) {
      createTermApplicant(
        applicantId: $applicantId,
        termId: $termId,
        applicationAccepted: $applicationAccepted,
        applicantStatus: $applicantStatus,
        applicationStatus: $applicationStatus,
        answers: $answers ) {
        termApplicant
        {
          termApplicantId
          termId{
            termId
          }  
          applicantId{
            applicantId
          }
          applicationAccepted
          applicantStatus
          applicationStatus 
        }
      }
    }
`;

const UpdateTermApplicantFeedback_mutate = `
    mutation UpdateTermApplicantFeedback( 
      $termApplicantId: Int!     
      $feedback: String
      $feedbackOverall: String!     
      ) {
      updateTermApplicantFeedback(
        termApplicantId: $termApplicantId,
        feedback: $feedback,
        feedbackOverall: $feedbackOverall,
        ) {
        termApplicant
        {
          termApplicantId
          termId{
            termId
          }  
          applicantId{
            applicantId

          }
          feedback
          feedbackBy
          feedbackDate 
          applicationAccepted
          applicantStatus
          applicationStatus 
        }
      }
    }
`;

const AcceptQualifiedApplicant_mutate = `
    mutation acceptQueslifiedApplicants( 
      $termApplicantIds: [Int!]!
      ) {
      acceptQueslifiedApplicants(
        termApplicantIds: $termApplicantIds) {
         response
      }
    }
`;

const NotifyApplicants_mutate = `
    mutation notifyApplicants( 
      $qualifiedApplicantIds: [Int!]!
      $unQualifiedApplicantIds: [Int!]!
      ) {
      notifyApplicants(
        qualifiedApplicantIds: $qualifiedApplicantIds,
        unQualifiedApplicantIds: $unQualifiedApplicantIds) {
         response
      }
    }
`;

const RenotifyApplicants_mutate = `
    mutation renotifyApplicants( 
      $qualifiedApplicantIds: [Int!]!      
      ) {
      renotifyApplicants(
        qualifiedApplicantIds: $qualifiedApplicantIds)
         {
         response
      }
    }
`;

const GetAllApplicantsByTermId_query = `
  query( $termId: Int!)
  {
    getAllApplicantsByTermId(termId: $termId)
    {      
      termApplicantId
      applicantId{
        applicantId
        viaForm
        userId{
          username
          firstName
          lastName
          email
          phoneNo
          city 
          state
          country
          linkedinUrl
        }
        createBy
        createDate
      }
      termId{
        termId
        termUuid
        formId{
          formId
          formUuid
        }
      }  
      applicationAccepted
      applicantStatus
      applicationStatus
      totalAssignedScore
      totalAwardedScore
      optInOutDecision
      note
      feedback
      feedbackBy
      feedbackDate
      feedbackOverall
      updateDate
      applicantNotified
      applicantNotifiedDate
    }
  }    
`;

const GetSelectedApplicantsByTermId_query = `
  query( $termUuid: String!)
  {
    getSelectedApplicantsByTermId(termUuid: $termUuid)
    {      
      termApplicantId
      applicantId{
        applicantId
        userId{
          username
          firstName
          lastName
          email
        }
        createBy
        createDate
      }
      termId{
        termId
        termUuid
        formId{
          formId
          formUuid
        }
      }  
      applicationAccepted
      applicantStatus
      applicationStatus
      totalAssignedScore
      totalAwardedScore
      applicantNotified
      applicantNotifiedDate
    }
  }    
`;

const GetUnSelectedApplicantsByTermId_query = `
  query( $termUuid: String!)
  {
    getUnSelectedApplicantsByTermId(termUuid: $termUuid)
    {      
      termApplicantId
      applicantId{
        applicantId
        userId{
          username
          firstName
          lastName
          email
        }
        createBy
        createDate
      }
      termId{
        termId
        termUuid
        formId{
          formId
          formUuid
        }
      }  
      applicationAccepted
      applicantStatus
      applicationStatus
      totalAssignedScore
      totalAwardedScore
      applicantNotified
      applicantNotifiedDate
    }
  }    
`;

const GetApplicantDataByTermApplicantId_query = `
  query( $termApplicantId: Int!)
  {
    getApplicantDataByTermApplicantId(termApplicantId: $termApplicantId)
    {      
      termApplicantId
      applicantId{
        applicantId
        userId{
          username
          firstName
          lastName
          email
        }
        createBy
        createDate
      }
      termId{
        termId
        termUuid
        formId{
          formId
          formUuid
          name
        }
      }  
      applicationAccepted
      applicantStatus
      applicationStatus
      totalAssignedScore
      totalAwardedScore
      optInOutDecision
      note
      feedback
      feedbackBy
      feedbackDate
      updateDate
      updateBy
    }
  }    
`;

const EditTermApplicant_mutate = `
  mutation editTermApplicant(
    $termApplicantId: Int!
    $termId: Int!
    $totalAssignedScore: Int!
    $totalAwardedScore: Int!
    $applicationAccepted: Boolean!
    $applicantStatus: String
    $applicationStatus: String
    ) {
    editTermApplicant(
      termApplicantId: $termApplicantId,
      termId: $termId,
      totalAssignedScore: $totalAssignedScore,
      totalAwardedScore: $totalAwardedScore,
      applicationAccepted: $applicationAccepted,
      applicantStatus: $applicantStatus,
      applicationStatus: $applicationStatus ) 
    {
      termApplicant
      {
        termApplicantId
        termId{
          termId
        }
        totalAssignedScore
        totalAwardedScore
        applicationAccepted
        applicantStatus
        applicationStatus
      }
    }
  }
`;

const EditTermApplicantOptInOut_mutate = `
  mutation editTermApplicantOptInOut(
    $termApplicantId: Int!    
    $optInOutDecision: Boolean!
    $note: String
    ) {
    editTermApplicantOptInOut(
      termApplicantId: $termApplicantId,      
      optInOutDecision: $optInOutDecision,
      note: $note ) 
    {
      termApplicant
      {
        termApplicantId
        termId{
          termId
        }
        totalAssignedScore
        totalAwardedScore
        applicationAccepted
        applicantStatus
        applicationStatus
        optInOutDecision
        note
        updateDate
      }
    }
  }
`;

const GetAllTermApplicantsByApplicantId_query = `
  query( $applicantId: Int!)
  {
    getAllTermApplicantsByApplicantId(applicantId: $applicantId)
    {      
      termApplicantId
      applicantId
      {
        userId
        {
          username
        }    
      }
      termId
      {
        name
        startDate
        endDate
        period
      }
      createDate
      applicationStatus
      applicantStatus
    }
  }    
`;

const GetAllTermApplicantsByApplicantIdClientId_query = `
  query( $applicantId: Int!
         $clientId: Int!)
  {
    getAllTermApplicantsByApplicantIdClientId(applicantId: $applicantId,
                                              clientId: $clientId)
    {      
      termApplicantId
      applicantId
      {
        viaForm
        userId
        {
          username
        }    
      }
      termId
      {
        termId
        termUuid
        name
        startDate
        endDate
        period
        current
      }
      createDate
      applicationStatus
      applicantStatus
      applicationAccepted
    }
  }    
`;

const GetAllTermApplicantsByApplicantIdTermId_query = `
  query( $applicantId: Int!
         $termId: Int!)
  {
    getAllTermApplicantsByApplicantIdTermId(
      applicantId: $applicantId,
      termId: $termId)
    {      
      termApplicantId
      applicantId
      {
        userId
        {
          username
        }    
      }
      termId
      {
        termUuid
        name
        startDate
        endDate
        period
      }
      createDate
      applicationStatus
      applicantStatus
    }
  }    
`;

module.exports = {
  CREATE_TERM_APPLICANT_MUTATION: CreateTermApplicant_mutate,
  GET_ALL_APPLICANTS_BY_TERM_ID_QUERY: GetAllApplicantsByTermId_query,
  GET_SELECTED_APPLICANTS_BY_TERM_ID_QUERY: GetSelectedApplicantsByTermId_query,
  GET_UN_SELECTED_APPLICANTS_BY_TERM_ID_QUERY: GetUnSelectedApplicantsByTermId_query,
  GET_APPLICANT_DATA_BY_TERM_APPLICANT_ID_QUERY: GetApplicantDataByTermApplicantId_query,
  EDIT_TERM_APPLICANT_MUTATE: EditTermApplicant_mutate,
  EDIT_TERM_APPLICANT_OPT_IN_OUT_MUTATE: EditTermApplicantOptInOut_mutate,
  GET_ALL_TERM_APPLICANT_BY_APPLICANT_ID: GetAllTermApplicantsByApplicantId_query,
  GET_ALL_TERM_APPLICANT_BY_APPLICANT_ID_CLIENT_ID:
    GetAllTermApplicantsByApplicantIdClientId_query,
  GET_ALL_TERM_APPLICANT_BY_APPLICANT_ID_TERM_ID:
    GetAllTermApplicantsByApplicantIdTermId_query,
  ACCEPT_QUALIFIED_APPLICANT_MUTATE: AcceptQualifiedApplicant_mutate,
  NOTIFY_APPLICANTS_MUTATE: NotifyApplicants_mutate,
  RENOTIFY_APPLICANTS_MUTATE: RenotifyApplicants_mutate,
  UPDATE_TERM_APPLICANT_FEEDBACK_MUTATE: UpdateTermApplicantFeedback_mutate,
};
